export default {
  "autresServices": {
    "heroTitle": "خدمات تقنية أخرى",
    "heroSubtitle": "خدمات تكميلية لمرافقة مشاريعكم من الألف إلى الياء بخبرتنا التقنية متعددة التخصصات",
    "intro": "بالإضافة إلى حلولنا الطاقوية، تضع IS TELECOM تحت تصرفكم مجموعة كاملة من الخدمات التقنية لضمان نجاح مشاريعكم.",
    "prestationsLabel": "خدماتنا:",
    "subServicesLabel": "الخدمات المرتبطة:",
    "ctaLink": "ناقش مشروعك",
    "whyUs": {
      "title": "لماذا تختار خدماتنا التقنية؟",
      "items": [
        {"title": "شهادات معترف بها", "desc": "فرقنا معتمدة وفقًا لأكثر المعايير الدولية صرامة (ISO، CE، TUV)."},
        {"title": "فريق متعدد التخصصات", "desc": "مهندسون وتقنيون ومعماريون واستشاريون مجتمعون لتغطية جميع جوانب مشروعكم."},
        {"title": "ضمان الجودة", "desc": "كل خدمة يتم فحصها والمصادقة عليها وضمانها. نحن لا نسلم إلا ما يلبي معاييرنا."}
      ]
    },
    "cta": {
      "title": "مشروع معقد؟ لدينا الحل.",
      "subtitle": "مهما كانت حاجتكم التقنية، يجد فريقنا متعدد التخصصات الإجابة المناسبة.",
      "button": "تحدث إلى خبير"
    },
    "services": [
      {
        "id": "audit",
        "title": "التدقيق والاستشارات",
        "fullDesc": "يقوم فريق خبرائنا بإجراء تدقيقات طاقوية شاملة لتحليل منشآتكم الحالية وتحديد مجالات التحسين. كل توصية تتكيف مع الاحتياجات الخاصة لمشروعكم.",
        "details": ["تشخيص طاقوي كامل في الموقع", "تحليل الاستهلاك التاريخي", "دراسة الجدوى التقنية والاقتصادية", "توصيات مخصصة مع عائد استثمار مقدر", "المساعدة في البحث عن التمويل"]
      },
      {
        "id": "expertise",
        "title": "الخبرة التقنية",
        "fullDesc": "يتدخل خبراؤنا التقنيون للمصادقة على مطابقة منشآتكم، واعتماد الأداء واقتراح التحسينات. نضمن سلامة وموثوقية وأداء أنظمتكم الطاقوية.",
        "details": ["خبرة قضائية وتقنية", "اعتماد المنشآت القائمة", "تحسين الأداء الطاقوي", "التحقق من المطابقة التنظيمية", "تقارير خبرة مفصلة"]
      },
      {
        "id": "informatique",
        "title": "تقنية المعلومات",
        "fullDesc": "ننشر بنى تحتية معلوماتية كاملة لدعم مشاريعكم الطاقوية: شبكات، خوادم، أنظمة مراقبة، منصات إدارة الطاقة وحلول الأمن السيبراني.",
        "details": ["نشر الشبكات المحلية والواسعة", "تكوين الخوادم ومراكز البيانات", "منصات مراقبة الطاقة", "أمن المعلومات والأمن السيبراني", "الدعم التقني وصيانة تقنية المعلومات"]
      },
      {
        "id": "environnement",
        "title": "الخدمات البيئية",
        "fullDesc": "نرافق مشاريعكم في امتثالها البيئي: دراسات الأثر، البصمة الكربونية، الشهادات البيئية والاستشارات في التنمية المستدامة.",
        "details": ["دراسات الأثر البيئي", "البصمة الكربونية واستراتيجية الخفض", "الشهادات البيئية (LEED، BREEAM)", "استشارات الاقتصاد الدائري", "إدارة النفايات الإلكترونية"]
      },
      {
        "id": "btp",
        "title": "الإنشاءات المعدنية والهندسة المدنية",
        "fullDesc": "يقوم قسم الهندسة المدنية والإنشاءات المعدنية لدينا بتصنيع وتركيب هياكل مخصصة لمشاريعكم الطاقوية: إطارات، دعامات الألواح، مباني تقنية وبنى تحتية للهندسة المدنية.",
        "details": ["تصنيع الهياكل المعدنية المخصصة", "الهندسة المدنية والأساسات المتخصصة", "بناء المباني التقنية والمحطات الفرعية", "تركيب الأسوار وتأمين المواقع", "أعمال التجديد والتوسعة"]
      },
      {
        "id": "telecom",
        "title": "الاتصالات",
        "fullDesc": "تنشر IS TELECOM بنى تحتية كاملة للاتصالات: تركيب الأبراج والأعمدة، نشر شبكات الألياف البصرية واللاسلكية، صيانة معدات الراديو وحلول الاتصال للمناطق الريفية والحضرية.",
        "details": ["تركيب أبراج وأعمدة الاتصالات", "نشر شبكات الألياف البصرية واللاسلكية", "الصيانة الوقائية والتصحيحية لمعدات الراديو", "حلول الاتصال للمناطق الريفية المعزولة", "التكامل مع البنى التحتية الشمسية القائمة"]
      },
      {
        "id": "transport",
        "title": "النقل والخدمات اللوجستية",
        "fullDesc": "نتولى نقل ولوجستيات معداتكم الطاقوية ومعدات الاتصالات عبر أفريقيا وخارجها. من المناولة المتخصصة إلى التسليم الجاهز في الموقع، نضمن سلامة والتزام مواعيد شحناتكم.",
        "details": ["النقل البري والبحري للمعدات الثقيلة", "المناولة المتخصصة للألواح الشمسية والبطاريات", "لوجستيات المشاريع وسلسلة التوريد", "الجمارك والإدارة الإدارية للشحنات", "التسليم الجاهز في المواقع المعزولة"],
        "subServices": [
          {
            "id": "location",
            "title": "تأجير المعدات",
            "desc": "نقدم خدمة تأجير المعدات الثقيلة والمعدات المتخصصة لمواقع البناء الخاصة بكم: الرافعات، منصات العمل الهوائية، الجرافات، الحفارات، الضواغط والشاحنات القلابة. تتم صيانة معداتنا بانتظام وهي متاحة مع أو بدون مشغل مؤهل حسب احتياجاتكم.",
            "details": ["تأجير الرافعات المتحركة والبرجية", "منصات العمل الهوائية والرافعات التلسكوبية", "معدات الحفر: الجرافات، الحفارات، الممهدة", "الضواغط والمداحل والرصف", "الشاحنات القلابة ومركبات نقل المواد", "عقود قصيرة أو طويلة الأجل، مع أو بدون مشغل"]
          }
        ]
      }
    ]
  }
};